import { useState } from "react";

const SEVERITY_CONFIG = {
  success: { icon: "✅", color: "#059669", bg: "#f0fdf4" },
  info:    { icon: "ℹ️", color: "#2563eb", bg: "#eff6ff" },
  warning: { icon: "⚠️", color: "#d97706", bg: "#fffbeb" },
  danger:  { icon: "🔴", color: "#dc2626", bg: "#fef2f2" },
};

function timeAgo(dateStr) {
  const diff = Date.now() - new Date(dateStr).getTime();
  const m = Math.floor(diff / 60000);
  if (m < 1)  return "à l'instant";
  if (m < 60) return `il y a ${m} min`;
  const h = Math.floor(m / 60);
  if (h < 24) return `il y a ${h}h`;
  const d = Math.floor(h / 24);
  if (d < 7)  return `il y a ${d}j`;
  return new Date(dateStr).toLocaleDateString("fr-FR");
}

export default function NotificationItem({ notif, onRead, onArchive, onNavigate }) {
  const [hovered, setHovered] = useState(false);
  const cfg = SEVERITY_CONFIG[notif.severity] || SEVERITY_CONFIG.info;
  const isUnread = !notif.is_read;

  const handleClick = () => {
    if (isUnread) onRead(notif.id);
    if (notif.link) onNavigate?.(notif.link);
  };

  return (
    <div
      onClick={handleClick}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      style={{
        display: "flex", alignItems: "flex-start", gap: 12,
        padding: "12px 16px",
        background: isUnread ? "#eff6ff" : hovered ? "#f9fafb" : "#ffffff",
        borderBottom: "1px solid #f3f4f6",
        cursor: notif.link ? "pointer" : "default",
        transition: "background 0.15s",
        position: "relative",
      }}
    >
      {/* Dot non lu */}
      {isUnread && (
        <div style={{ position: "absolute", top: 14, left: 6, width: 6, height: 6, borderRadius: "50%", background: "#2563eb", flexShrink: 0 }} />
      )}

      {/* Icône severity */}
      <div style={{
        width: 34, height: 34, borderRadius: 8, background: cfg.bg,
        display: "flex", alignItems: "center", justifyContent: "center",
        fontSize: 16, flexShrink: 0,
      }}>
        {cfg.icon}
      </div>

      {/* Contenu */}
      <div style={{ flex: 1, minWidth: 0 }}>
        <div style={{ fontSize: 13, fontWeight: isUnread ? 700 : 500, color: "#111827", lineHeight: 1.4, marginBottom: 2 }}>
          {notif.title}
        </div>
        <div style={{ fontSize: 12, color: "#6b7280", lineHeight: 1.5, marginBottom: 4 }}>
          {notif.message}
        </div>
        <div style={{ fontSize: 11, color: "#9ca3af" }}>
          {timeAgo(notif.created_at)}
        </div>
      </div>

      {/* Bouton archive — visible au hover */}
      {hovered && (
        <button
          onClick={e => { e.stopPropagation(); onArchive(notif.id); }}
          title="Archiver"
          style={{
            background: "none", border: "none", color: "#9ca3af",
            cursor: "pointer", padding: "4px 6px", borderRadius: 6, fontSize: 14,
            flexShrink: 0, alignSelf: "center",
          }}
          onMouseEnter={e => { e.currentTarget.style.color = "#6b7280"; e.currentTarget.style.background = "#f3f4f6"; }}
          onMouseLeave={e => { e.currentTarget.style.color = "#9ca3af"; e.currentTarget.style.background = "none"; }}
        >
          ✕
        </button>
      )}
    </div>
  );
}
